define('common/utils/optimisedMapper',['underscore'], function(_) {

    function concatObject(object, item, key) {
        object[key] = item;
        return object;
    }

    function concatArray(array, item) {
        return array.concat(item);
    }

    /**
     * Use this to optimise a repeated map operation over a list
     *
     * Creates a mapper function that will keep a short term cache of previously
     * mapped items, so that if the list changes but the items themselves don't,
     * there is no need to recalculate them.
     *
     * @param {Function} mapFn
     *
     * @param {Function} itemHashFn   Return a string, uniquely identifying items
     *                                that will be mapped.
     *
     * @param {Function} stateHashFn  Return a string identifying the current state
     *                                of dependencies for this mapping. When this
     *                                string changes, the mapper knows to drop its
     *                                store.
     *
     * @return {Function}  Accepts either an array or dictionary of items to map.
     */
    function optimisedMapper(mapFn, itemHashFn, stateHashFn) {

        var store = {},
            lastStateHash;

        return function(items) {

            var newStateHash = stateHashFn(),
                baseIterable = {},
                concatFn = concatObject;

            if (_.isArray(items)) {
                baseIterable = [];
                concatFn = concatArray;
            }

            if (newStateHash !== lastStateHash) {
                lastStateHash = newStateHash;
                store = {};
            }

            return _.reduce(
                items,
                function(memo, item, key) {
                    var itemHash = itemHashFn(item);

                    if (!store.hasOwnProperty(itemHash)) {
                        store[itemHash] = mapFn(item);
                    }

                    return concatFn(memo, store[itemHash], key);
                },
                baseIterable
            );
        };

    }

    return optimisedMapper;

});

